export default "__VITE_ASSET__D0P9PnSh__"